// extracted by mini-css-extract-plugin
export default {"postPage":"G+Ew8","emptyState":"B30Na","recentPosts":"FU1HN"};